import { render, staticRenderFns } from "./NationalTrademarkApplicationType.vue?vue&type=template&id=08344648&"
import script from "./NationalTrademarkApplicationType.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkApplicationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports